

import Forget from './Forget.vue';
import Login from './Login.vue';
import Signup from './Signup.vue';
import Welcome from './Welcome.vue';
import Error from './Error.vue';
import Confirm from './Confirm.vue';
import Invitation from './Invitation.vue';
import Verification from './Verification.vue';
import Thanks from './Thanks.vue';
import Change from './Change.vue';
import Contact from './Contact.vue';
import Personal from './Personal.vue';
import Terms from './Terms.vue';
import Notation from './Notation.vue';
import WelcomePhone from './WelcomePhone.vue';
import Coming from './Coming.vue';
import Help from './Help.vue';
import Maintenance from './Maintenance.vue';
import Invoice from './Invoice.vue';

export default {
  Forget,
  Login,
  Signup,
  Welcome,
  Error,
  Confirm,
  Invitation,
  Verification,
  Thanks,
  Change,
  Contact,
  Personal,
  Terms,
  Notation,
  WelcomePhone,
  Coming,
  Maintenance,
//  Help,
  Invoice,
};
